let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5lkHF")).then(() => parcelRequire('8ymsB'));